import Vue from 'vue'
import createMessage from '@/services/app/createMessage'
import { Message, MessageType } from '@/interfaces/app/Message'

Vue.prototype.$createMessage = createMessage
declare module 'vue/types/vue' {
  interface Vue {
    $createMessage(messageText: string, type?: MessageType): Message
  }
}
